import React from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import config from "~/config";
import AspectPropType from "~/prop-types/aspect";
import Weight from "~/components/Weight";
import styles from "./styles.module.scss";
import Range from "./Range";
import ListGroup from "react-bootstrap/ListGroup";
import Checkbox from "~/components/Checkbox";

export default class RangeAspectEditor extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        aspect: AspectPropType.isRequired,
        isEditing: PropTypes.bool.isRequired,
        forceAspectRequiredCheckbox: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        forceAspectRequiredCheckbox: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            newRange: createNewRange(),
        }
    }

    reset() {
        this.setState({newRange: createNewRange()})
    }

    render() {
        return (
            <Card className={styles.aspectEditor}>
                {this.renderHeader()}
                <ListGroup variant="flush">{this.renderRange()}</ListGroup>
            </Card>
        );
    }

    renderHeader() {
        const {title, aspect, isEditing, forceAspectRequiredCheckbox} = this.props;

        return (
            <Card.Header className={styles.cardHeader}>
                {(forceAspectRequiredCheckbox || !config("ui.hideAspectRequiredCheckbox")) && (
                    <Checkbox
                        checked={aspect.required}
                        disabled={!isEditing}
                        onChange={this.handleRequiredChange}
                    />
                )}
                <span>{title}</span>
                <Weight
                    value={aspect.weight}
                    isEditing={isEditing}
                    className="ml-auto"
                    onChange={this.handleWeightChange}
                />
            </Card.Header>
        );
    }

    renderRange() {
        const {aspect, isEditing} = this.props;

        if (aspect.value) {
            return (
                <Range
                    value={aspect.value}
                    isEditing={isEditing}
                    onChange={this.handleRangeChange}
                />
            );
        } else if (isEditing) {
            const {newRange} = this.state;

            return (
                <Range
                    value={newRange}
                    isEditing={true}
                    onChange={this.handleRangeChange}
                />
            );
        } else {
            return null;
        }
    }

    handleRangeChange = range => {
        const {name, aspect, onChange} = this.props;

        if (range.from !== undefined && range.to !== undefined) {
            onChange(name, {...aspect, value: range});
        } else {
            onChange(name, {...aspect, value: null});
            this.setState({newRange: range});
        }
    };

    handleWeightChange = nextWeight => {
        const {name, aspect, onChange} = this.props;

        onChange(name, {
            ...aspect,
            weight: nextWeight,
        });
    };

    handleRequiredChange = nextRequired => {
        const {name, aspect, onChange} = this.props;

        onChange(name, {
            ...aspect,
            required: nextRequired,
        });
    };
}

function createNewRange() {
    return {
        weight: config("ui.weight.default"),
        required: false,
        from: undefined,
        to: undefined,
    };
}
